




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import Clipboard from '@/plugins/Clipboard';
import { computeHighLightNumberHelper } from '@/heplers';
import { State } from 'vuex-class';

@Component({
  components: {
    DocIcon,
  },
})
export default class CopyCodeButton extends Vue {
  @Prop({ default: '' }) codeForCopy: string;
  @Prop() highlight: string[];
  @State isMobile: boolean;
  public hoverState = false;
  private isCopied = false;

  get preparedCodeForCopy() {
    return this.computeLinesForCopy(this.codeForCopy, this.highlight);
  }

  copyToClipboard() {
    this.isCopied = true;

    Clipboard.copy(`${this.preparedCodeForCopy}`);
    setTimeout(() => (this.isCopied = false), 2000);
  }

  private computeLinesForCopy(source: string, highlight: string[]) {
    if (!highlight || !highlight.length) return source;

    const trimmedHighlight = highlight.filter((value) => value !== '');
    if (!trimmedHighlight.length) return source;

    const highlightArrayNumbers: number[] = computeHighLightNumberHelper(trimmedHighlight);

    let linesForCopy: string[] = [];

    linesForCopy = source
      .match(/.*\n/g)
      .filter((value: string, index: number) => highlightArrayNumbers.includes(index + 1));

    return linesForCopy.join('');
  }
}
